import React from 'react'
import calculateTimeLeftUtil from 'utils/date/calculate-time-left'
import updateCurrentDateProductsAction from 'modules/product/redux/actions/update-current-date'
import useDispatch from 'hooks/use-dispatch'

const DEFAULT_INTERVAL = 1000

const useCountdown = (targetDate) => {
  const [timeLeft, setTimeLeft] = React.useState(calculateTimeLeftUtil(targetDate))
  const dispatch = useDispatch()

  React.useEffect(() => {
    setTimeLeft(calculateTimeLeftUtil(targetDate))

    const timer = setInterval(() => {
      const currentDate = new Date()
      dispatch(updateCurrentDateProductsAction(currentDate))
      setTimeLeft(calculateTimeLeftUtil(targetDate))
    }, DEFAULT_INTERVAL)

    return () => clearInterval(timer)
  }, [targetDate])

  return [
    timeLeft.days,
    timeLeft.hours,
    timeLeft.minutes,
    timeLeft.seconds
  ]
}

export default useCountdown
